import { mapGetters } from 'vuex';
import Product from 'aa/vue/models/Product';
import Domain from 'helpers/Domain';
import { PAGE_TYPES, tracking } from 'services/Tracking';
import {
    PAGE_TYPES as AA_PAGE_TYPES,
    ACTION_NAMES as AA_ACTION_NAMES,
} from 'aa/vue/constants/aaTrackingConstants';
import { FTC_COMPLIANCE_CHECKBOX_ENABLED } from 'aa/helpers/featureConstants';

export default {
    data() {
        return {
            isPaymentPage: true,
            isUserOriginalPlanTypeMonthly: true,
            featureAsterisk: false,
        };
    },
    //mixins: [NotificationMixin, modalMixin, syncdataMixin],
    computed: {
        ...mapGetters({
            upgradeAnnualToggle: 'featureFlags/upgradeAnnualToggle',
            selectedPlan: 'plan/selectedPlan',
            monthlySelectedAndAnnualAvailable: 'plan/monthlySelectedAndAnnualAvailable',
            annualSelectedAndMonthlyAvailable: 'plan/annualSelectedAndMonthlyAvailable',
        }),
        isUpgradeAnnualToggle() {
            return (
                this.upgradeAnnualToggle &&
                !this.isSinglePlanRegion &&
                this.isUserOriginalPlanTypeMonthly &&
                (this.canToggleFromMonthlyToAnnual || this.canToggleFromAnnualToMonthly)
            );
        },
        isSinglePlanRegion() {
            if (Domain.isDomestic()) {
                return false;
            } else if (Domain.getRegionCode() === 'de') {
                return true;
            }
            return false;
        },
        canToggleFromMonthlyToAnnual() {
            return (
                this.selectedPlan?.planType === Product.TYPE_MONTHLY &&
                this.monthlySelectedAndAnnualAvailable.length > 0
            );
        },
        canToggleFromAnnualToMonthly() {
            return (
                this.selectedPlan?.planType === Product.TYPE_ANNUAL &&
                this.annualSelectedAndMonthlyAvailable.length > 0
            );
        },
        trackingService() {
            return this.isSwitchPlan ? this.$trackingService : tracking;
        },
        commonFlowPageType() {
            if (this.isSwitchPlan) {
                return PAGE_TYPES.PLAN_CHANGE_CONFIRMATION;
            }

            return this.isExSubscriber ? AA_PAGE_TYPES.EXSUB_PAYMENT : AA_PAGE_TYPES.PAYMENT;
        },
    },
    methods: {
        /**
         * Get the switch state value from local storage.
         *
         * @returns {boolean}
         */
        togglePlanType(
            switchToAnnual,
            // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
            isUpgradePremiumToggle = false,
        ) {
            // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment

            const planToSwitchTo = this.$store.getters['plan/getTargetPlanForUpgradeToggle'](
                switchToAnnual,
                isUpgradePremiumToggle,
            );

            if (!planToSwitchTo) {
                return;
            }

            if (this.showCheckbox) {
                // Set the cooling rights waived state to false only if the checkbox flag is true to avoid breaking payments
                this.$store.commit('ftc/setCoolingRightsWaived', false);
            }

            this.$store.dispatch('plan/updateSelectedPlan', planToSwitchTo);
            this.$store.dispatch('plan/setPlanType', planToSwitchTo.planType);
            this.trackAnnualToggleClick(planToSwitchTo, switchToAnnual, isUpgradePremiumToggle);
        },

        trackAnnualToggleClick(
            plan,
            switchToAnnual,
            // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
            isUpgradePremiumToggle,
            // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
        ) {
            let planTitle = plan.titleForTracking ?? '';

            if (Domain.isInternational()) {
                planTitle = plan.planTier ?? '';
            }

            const trackingParams = {
                pickPlanIsAnnual: switchToAnnual.toString(),
                pickPlanSku: plan.recurlyCode ?? '',
                pickPlanType: planTitle,
                productOfferPeriod: plan.trialString ?? '',
                productPricingPlan: plan.planType ?? '',
                purchasePrice: plan.rawPrice ?? '',
                purchaseProduct: plan.recurlyCode ?? '',
                purchaseProductName: plan.titleForTracking ?? '',
                purchaseQuantity: '1',
                pageType: this.commonFlowPageType,
            };

            const trackingAction =
                this.isUpgradeAnnualToggle === true
                    ? AA_ACTION_NAMES.PAYMENT_ANNUAL_PLAN_TOGGLE
                    : AA_ACTION_NAMES.SELECT_NEW_BILLING_CADENCE;

            // START TEST CBSCOMSUB-10538 Upgrade to Premium on Payment
            if (isUpgradePremiumToggle) {
                const abTestTracking = {
                    ...trackingParams,
                    pickPlanIsPremium: switchToAnnual.toString(),
                    pickPlanIsAnnual: null,
                };

                this.trackingService.trackAction('trackPaymentPremiumPlanToggle', abTestTracking);
                return;
            }
            // END TEST CBSCOMSUB-10538 Upgrade to Premium on Payment

            this.trackingService.trackAction(trackingAction, trackingParams);
        },
    },
};
